<template>
  <v-container>
    <h3>SA&I</h3>
    <SaiBaseList/>
  </v-container>
</template>

<script>

import SaiBaseList from '@/components/Gl/Sai/SaiBaseList.vue';

export default {
  name: 'Sai',
  components: {
    SaiBaseList,
  },
};
</script>
